import { Component, OnInit, Input } from '@angular/core';
import { MapService, iconVehicle } from '@app/shared/services/map.service';
import * as L from 'leaflet';


@Component({
  selector: 'app-position-vehicle',
  templateUrl: './position-vehicle.component.html',
  styleUrls: ['./position-vehicle.component.scss']
})
export class PositionVehicleComponent {

  private map: L.Map = null;
  private marker: L.Marker = null;

  @Input() latitude: number = 0;
  @Input() longitude: number = 0;

  constructor(
    private mapService: MapService
  ) { }

  ngOnChanges(): void {
    if (this.latitude === undefined || this.longitude === undefined) {
      return;
    }
    if (this.map && this.map.remove) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }
    this.mapService.initMap("reposition", [this.latitude, this.longitude], 12, false).then((map) => {
      this.map = map;
      this.addMarker([this.latitude, this.longitude]);
      this.fixCenter();
    });

    this.mapService.map.scrollWheelZoom.enable();
  }

  fixCenter(): void {
    setTimeout(() => {
      let latLngs = [this.marker.getLatLng()];
      let markerBounds = L.latLngBounds(latLngs);

      this.map.invalidateSize();
      this.map.fitBounds(markerBounds);
      this.map.setZoom(12);
    });
  }

  addMarker(position): void {
    this.marker = L.marker(position, {
      icon: iconVehicle
    }).addTo(this.map);
  }

}
